module.exports = __webpack_public_path__ + "static/media/ja.1f905d23.svg";